export enum SessionStorageKeys {
    LOGIN_HINT_DISPLAYED = 'login-hint-displayed',
    PREFERRED_LOGIN_EMAIL = 'preferred-login-email',
}
